import React from "react";
import point from "./../../../Images/point.png";

const OctopusHairCutHow = () => {
  return (
    <div className="faceWhyContainer">
      <h5>How to Style the Octopus Haircut</h5>
      <p>
        Styling the Octopus Haircut for Women in Bangalore is simple and fun.
        Here are a few tips to help you achieve the perfect look:
      </p>
      <ul>
        <li>
          <span>
            <img src={point} alt="" />
            For a Casual Look{" "}
          </span>
          <p>
            For a laid-back, everyday style, apply a lightweight mousse or sea
            salt spray to damp hair. Scrunch your hair with your fingers and let
            it air dry for a beachy, textured finish. This effortless look
            showcases the layers of the Octopus Haircut, giving you a relaxed
            vibe perfect for running errands or meeting friends.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="" />
            For a Polished Finish{" "}
          </span>
          <p>
            If you're heading to a more formal event, consider using a flat iron
            or curling wand to create sleek, polished waves. Simply section your
            hair and curl away from your face, then gently run your fingers
            through your hair to create soft, elegant waves. Finish with a shine
            spray to enhance the glossy finish of your Octopus Haircut.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="" />
            Accessorize!{" "}
          </span>
          <p>
            Don't forget to accessorize your Octopus Haircut with headbands,
            clips, or hairpins to elevate your style. A simple accessory can add
            a touch of personality and flair to your look, making it even more
            unique.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default OctopusHairCutHow;
